import $ from 'jquery';
import 'jssocials';
import ClipboardJS from 'clipboard';
import utils from '../../shared/utils';

const jsSocials = window.jsSocials;

function initSocials(settings) {
    const {referrerId, descriptionText} = settings;

    const cssDefaults = {
        elementClass: 'js-scls',
        sharesClass: 'js-scls-shares',
        shareClass: 'js-scls-share',
        shareButtonClass: 'js-scls-share-button',
        shareLinkClass: 'js-scls-share-link',
        shareLogoClass: 'js-scls-share-logo',
        shareLabelClass: 'js-scls-share-label',
        shareLinkCountClass: 'js-scls-share-link-count',
        shareCountBoxClass: 'js-scls-share-count-box',
        shareCountClass: 'js-scls-share-count',
        shareZeroCountClass: 'js-scls-share-no-count',
    };

    jsSocials.setDefaults(cssDefaults);

    jsSocials.Socials.prototype._renderShare = function(share) {
        let $share;

        if ($.isFunction(share.renderer)) {
            $share = $(share.renderer());
        } else {
            $share = this._createShare(share);
        }

        $share.addClass(this.shareClass)
            .addClass(share.share ? `js-scls-share-${share.share}` : '')
            .addClass(share.css)
            .appendTo(this._$shares);

        const id = `${settings.shareActionButtonPrefix}${utils.genUid()}`;
        $share[0].setAttribute('id', id);
    };

    jsSocials.shares.facebook = {
        share: 'facebook',
        descriptionText,
        shareUrl: 'https://facebook.com/sharer/sharer.php?u={url}{referrerSource}{referrerId}&quote={descriptionText}',
        referrerSource: '?rs=fb',
        referrerId,
        logo: 'fab fa-facebook',
        countUrl: 'https://graph.facebook.com/?id={url}{referrerSource}{referrerId}',
        getCount(data) {
            return data.count;
        },
    };
    jsSocials.shares.twitter = {
        share: 'twitter',
        shareUrl: 'https://twitter.com/share?url={url}{referrerSource}{referrerId}&text={text}&via={via}&hashtags={hashtags}',
        referrerSource: '?rs=tw',
        referrerId,
        logo: 'fab fa-twitter',
        countUrl: '',
        getCount(data) {
            return data.count;
        },
    };
    jsSocials.shares.email = {
        share: 'email',
        shareUrl: 'mailto:{to}?subject={text}&body={url}{referrerSource}{referrerId}',
        referrerSource: '?rs=eml',
        referrerId,
        logo: 'fa fa-envelope',
        countUrl: '',
        getCount(data) {
            return data.count;
        },
    };
    jsSocials.shares.vkontakte = {
        label: 'vkontakte',
        logo: 'fab fa-vk',
        descriptionText,
        shareUrl: 'https://vk.com/share.php?url={url}{referrerSource}{referrerId}&image={imageUrl}&title={text}&description={descriptionText}',
        referrerSource: '?rs=vk',
        referrerId,
        countUrl: '',
        getCount(data) {
            return data.count;
        },
    };
    jsSocials.shares.odnoklassniki = {
        label: 'odnoklassniki',
        logo: 'fab fa-odnoklassniki',
        descriptionText,
        shareUrl: 'https://connect.ok.ru/offer?url={url}{referrerSource}{referrerId}&imageUrl={imageUrl}&title={text}&description={descriptionText}',
        referrerSource: '?rs=ok',
        referrerId,
        countUrl: '',
        getCount(data) {
            return data.count;
        },
    };

    jsSocials.shares.copy = {
        label: 'Copy link',
        logo: 'fa fa-link',
        shareUrl: 'javascript: (function(){ })()',
        countUrl: '',
        shareIn: 'self',
    };
}

function initCopyToClipboard(shareUrl, container, linkCopiedMessage, shareDropdown, referrerId = '') {
    const referrerSource = '?rs=lnk';
    const copyLinkClass = 'js-scls-share-copy';
    const copyContainerClass = 'js-scl__copy-url';
    const copyUrlContainer = `.${copyContainerClass}`;

    const shareUrlCopy = `${shareUrl}${referrerSource}${referrerId}`;

    const copyUrlLayout = `<div class='js-scl__copy-url'>
                                <input class='input_size-s js-scl__copy-url-input' readonly="true" autofocus value='${shareUrlCopy}'/>
                           </div>`;
    const urlCopiedAlertLayout = `<div class='js-scl__copied-alert alert alert_info alert_size-s'>
                                        <i class='js-scl__copied-icon fa fa-clipboard'></i>
                                        ${linkCopiedMessage}
                                  </div>`;

    const shareContainer = $(container);
    const selector = shareContainer[0].classList.length ? `.${Array.from(shareContainer[0].classList).join('.')}` : '';
    const clickSelector = shareDropdown ? `.${copyLinkClass}` : `${selector} .${copyLinkClass}`;

    function appendCopyInfo(copySelector) {
        new ClipboardJS(document.querySelectorAll('.js-scls-share-copy i'), {text: () => shareUrlCopy}); // NOSONAR

        $(copySelector).click((e) => {
            // stopPropagation() to prevent dropdown close
            e.stopPropagation();

            shareContainer.find(copyUrlContainer).remove();
            shareContainer.append(copyUrlLayout);
            shareContainer.find(copyUrlContainer).prepend(urlCopiedAlertLayout);
            shareContainer.find('.js-scl__copy-url-input').select();
        });
    }

    if (shareDropdown) {
        $(shareDropdown).click(() => {
            appendCopyInfo(clickSelector);
        });

        $(shareDropdown).on('hidden.bs.dropdown',
            () => {
                shareContainer.find(copyUrlContainer).remove();
            });
    } else {
        $(document).ready(() => {
            appendCopyInfo(clickSelector);
        });

        $(document).click(function(e) {
            const targets = $(e.target).parents().addBack();
            const isLinkOrDropdownClicked = targets
                .filter((index, el) => $(el).hasClass(copyLinkClass) || $(el).hasClass(copyContainerClass)).length;
            if (!isLinkOrDropdownClicked) {
                shareContainer.find(copyUrlContainer).remove();
            }
        });
    }
}

export {initCopyToClipboard, initSocials};
